import crudAction from './actions'

export default {
  name: 'publicAmenities',
  namespace: 'public/amenities',
  methods: [
    ...crudAction,
  ]
}
